__turbopack_context__.v({
  "active": "OvyhTG_active",
  "hamburger-menu": "OvyhTG_hamburger-menu",
  "hamburger-menu__lines": "OvyhTG_hamburger-menu__lines",
  "menu-link": "OvyhTG_menu-link",
});
